import React from 'react';

import { StyledTabPanel } from './styles';

export interface TabPanelProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> {
  id: string;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, id, ...other }) => (
  <StyledTabPanel
    role="tabpanel"
    id={`panel-${id}`}
    aria-labelledby={`tab-${id}`}
    {...other}
  >
    {children}
  </StyledTabPanel>
);

export default TabPanel;
